




































import VueOptions from '@utils/VueOptions'
import CalendarUtils from '@utils/calendar'
import { RRule } from 'rrule'

export DEFAULT_MONTHLY_RRULE =
  freq: RRule.MONTHLY
  interval: 1

settings =
  name: 'MonthlyRuleForm'

  vue:
    props: ['form', 'actions']

    data: ->
      monthlyOption: 'date'

    mounted: -> 
      @initializeData()

    computed:
     monthlyOptions: ->
        { day, weekday, ordinality } = CalendarUtils.extractDataFromDate(@form.dateRange[0])
        { isLastWeek, isLastDay } = ordinality

        options = [
          {
            label: "On day #{day}",
            value: 'date',
            rrule: { bymonthday: day },
          },
          {
            label: "On the #{ordinality.label} #{weekday}",
            value: 'ordinal',
            rrule: { byweekday: RRule[weekday.slice(0, 2).toUpperCase()].weekday, bysetpos: ordinality.nth }
          }
        ]

        options.push {
          label: "On the Last #{weekday}",
          value: 'ordinal_last_week',
          rrule: { byweekday: RRule[weekday.slice(0, 2).toUpperCase()].weekday, bysetpos: -1 }
        } if isLastWeek

        options.push {
          label: "Last Day of the Month ",
          value: 'ordinal_last_day',
          rrule: { bymonthday: [28, 29, 30, 31], bysetpos: -1 }
        } if isLastDay

        options

    methods:
      hiDateRangeBlur: ->
        @hiMonthlyOptionChanged @monthlyOption
        @actions.onDateRangeBlur()

      hiMonthlyOptionChanged: (value) ->
        @monthlyOptionChanged value  
        @$emit 'change', @form

      monthlyOptionChanged: (value) ->
        { rrule } = @monthlyOptions.find((option) -> option.value is value)
        { freq, count, until: untilDate } = @form.rrule
        formRRule = { freq, ...rrule }
        formRRule.count = count if count
        formRRule.until = untilDate if untilDate
        @form.rrule = formRRule

      initializeData: ->
        @initializeMonthlyOption()
        @$emit 'change', @form

      initializeMonthlyOption: ->
        bysetpos = @form.rrule?.bysetpos
        bysetpos ||= []
        bysetpos = [bysetpos] unless Array.isArray bysetpos

        if @form.rrule?.bymonthday
          @monthlyOption = 'date'
          @monthlyOption = 'ordinal_last_day' if bysetpos?.includes -1

        else if @form.rrule?.byweekday and @form.rrule?.bysetpos
          if bysetpos?.includes -1
            @monthlyOption = 'ordinal_last_week'
          else
            @monthlyOption = 'ordinal'

        @monthlyOptionChanged @monthlyOption

export default VueOptions.vue settings
